@let $heading = heading();
@let $headingTemplate = headingTemplate();
@let $headingButtons = headingButtonsTemplate();
@let $footer = footerTemplate();
@let $hasTabs = this.tabs().length > 0;
@let $activeTab = activeTab();
@let $pageIcon = pageIcon();
@let $loading = loading();

<div class="pane" [class.pane-top]="!$hasTabs">
  @if ($loading) {
    Please wait...
  } @else {
    <div class="app-column gapped tight">
      @if ($headingTemplate) {
        <ng-container [ngTemplateOutlet]="$headingTemplate.template"/>
      } @else {
        <h1 class="app-row gapped tight centered-items">
          @if ($pageIcon) {
            <icon [type]="$pageIcon"/>
          }
          <span>{{ $heading }}</span>
        </h1>
      }
      @if ($headingButtons) {
        <div class="app-row gapped">
          <ng-container [ngTemplateOutlet]="$headingButtons.template"/>
        </div>
      }
    </div>
  }
</div>

@if ($hasTabs) {
  <div class="container app-fill tabs">
    <div class="app-column-fill app-fill-parent">
      <div class="app-row-auto gapped tight">
        @for ($tab of tabs(); track $tab) {
          <button
            class="tab"
            [title]="$tab.pageTab()"
            [class.active]="$tab === $activeTab"
            [routerLink]="['.']"
            [queryParams]="{tab: $tab.tabId()}"
            queryParamsHandling="merge"
          >
            @if ($tab.icon()) {
              <icon [type]="$tab.icon()!"/>
            }
            <span>{{ $tab.pageTab() }}</span>
          </button>
        }
      </div>

      <div class="pane pane-bottom container tab-content" [class.pane-top]="$footer">
        <div class="app-fill-parent container app-column-fill gapped">
          @for ($tab of tabs(); track $tab) {
            <div class="contents" [class.hidden]="$tab !== $activeTab">
              @if ($tab.rendered()) {
                <ng-container [ngTemplateOutlet]="$tab.template"/>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="pane pane-bottom container app-fill" [class.pane-top]="$footer">
    <div class="app-fill-parent container app-column-fill gapped">
      <ng-content/>
    </div>
  </div>
}

@if ($footer) {
  <div class="pane pane-bottom">
    <div class="app-row gapped tight">
      <ng-container [ngTemplateOutlet]="$footer.template"/>
    </div>
  </div>
} @else {
  <!--  <div class="contents"></div>-->
}
